import React, {useEffect} from 'react';
import styled from 'styled-components';
import OpenSeadragon from 'openseadragon';
import openseadragonselection from 'openseadragonselection';

const Osd = styled.div``;
var ordinal = 0;

function OsdComponent (props) {
  
  const initOsd = () => {
    const osdInstance = new OpenSeadragon({
      id: 'osd',
      prefixUrl: '/openseadragon/images/',
      sequenceMode: true,
      showZoomControl: false,
      showHomeControl: false,
      showFullPageControl: false,
      tileSources: props.images.map(image => `${props.imageBase}${image}`),
    });
    osdInstance.addHandler('page', function(e) {
      //props.setOrdinal(e.page);
      window.ordinal = e.page;
    });
    osdInstance.selection({
      allowRotation: false,
      onSelection: coords => props.sendSelection(coords),
    });
  }

  useEffect(() => {
    initOsd();
  }, []);

  return (
    <Osd id="osd" />
  );
}

export default OsdComponent;
